import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  sidebarShow: true,
};

export const UISlice = createSlice({
  name: "UI",
  initialState,
  reducers: {
    setSidebarShow: (state, { payload }) => {
      return {
        ...state,
        sidebarShow: payload,
      };
    },
  },
});

export const { setSidebarShow } = UISlice.actions;

export default UISlice.reducer;
